{
  "schemaVersion": 2,
  "id": "private-message",
  "stage": {
    "w": 941,
    "h": 1672
  },
  "stageScaleBase": {
    "w": 941,
    "h": 1672
  },
  "units": "stage units; all main element/text/hit x/y are stage-absolute, source slices are original PNG pixels",
  "sourceRoot": "repository root",
  "brief": "art/src/player-card-2026-10-07/message/BRIEF-CODEX-3.md",
  "defaultState": "idle",
  "reviewStatus": "Stage-3 design delivery only; no application implementation",
  "pieces": {
    "scrim": {
      "path": "apps/client/public/art/ui-extra/scrim.png",
      "pixelW": 16,
      "pixelH": 16,
      "alpha": true,
      "transparentPixels": 0,
      "partialAlphaPixels": 256,
      "sha256": "9cac0dbf8056303ae6dce23ca1c5fcfc6791e679fd5d3076f06887c08c67cd25",
      "reused": true,
      "uniformRgba": [
        4,
        6,
        20,
        184
      ]
    },
    "frame": {
      "path": "apps/client/public/art/howto-cut/slice/panel-9slice.png",
      "pixelW": 820,
      "pixelH": 814,
      "alpha": true,
      "transparentPixels": 14016,
      "partialAlphaPixels": 37364,
      "sha256": "96dbf2463e6872c9a11f970691a4d4605d093cb03e555c35362e63ecf6f5f540",
      "reused": true,
      "slicePx": {
        "top": 58,
        "right": 58,
        "bottom": 58,
        "left": 58
      }
    },
    "palm.tl": {
      "path": "apps/client/public/art/howto-cut/slice/palm-tl.png",
      "pixelW": 246,
      "pixelH": 222,
      "alpha": true,
      "transparentPixels": 10908,
      "partialAlphaPixels": 15012,
      "sha256": "b0fd25d7941794c9a457ee37d56f4f3b84486eb0854b3af932c271daa42119c3",
      "reused": true
    },
    "palm.tr": {
      "path": "apps/client/public/art/howto-cut/slice/palm-tr.png",
      "pixelW": 246,
      "pixelH": 222,
      "alpha": true,
      "transparentPixels": 10305,
      "partialAlphaPixels": 15132,
      "sha256": "717c8bf532a6ea7f0605b7cd94742b73d2cdc9afbddf22964b9e5cfec8c7d82d",
      "reused": true
    },
    "palm.bl": {
      "path": "apps/client/public/art/howto-cut/slice/palm-bl.png",
      "pixelW": 246,
      "pixelH": 222,
      "alpha": true,
      "transparentPixels": 12441,
      "partialAlphaPixels": 14732,
      "sha256": "0a338736cfed2fb14eeb9df5a500d9612cf372d379e2b67b9b4ad0bbb818cbe0",
      "reused": true
    },
    "palm.br": {
      "path": "apps/client/public/art/howto-cut/slice/palm-br.png",
      "pixelW": 246,
      "pixelH": 222,
      "alpha": true,
      "transparentPixels": 11859,
      "partialAlphaPixels": 14852,
      "sha256": "76bf41ca7d8c5860e47ef547671a69ce18ed46a4754de858e43a42b7bdada0be",
      "reused": true
    },
    "rule": {
      "path": "apps/client/public/art/howto-cut/slice/title-rule.png",
      "pixelW": 352,
      "pixelH": 28,
      "alpha": true,
      "transparentPixels": 0,
      "partialAlphaPixels": 9128,
      "sha256": "69bb07654abbca6f305378e60db87e901558045f9534e94a498c044d40582111",
      "reused": true
    },
    "close": {
      "path": "apps/client/public/art/ui4b/btn-close-x@2x.png",
      "pixelW": 232,
      "pixelH": 232,
      "alpha": true,
      "transparentPixels": 20528,
      "partialAlphaPixels": 33151,
      "sha256": "7fd5fd82aeacc15f679fbe74cfe7e10b3770f0b82185a02a14dd3c2287f020d3",
      "reused": true
    },
    "pill.large.png": {
      "path": "apps/client/public/art/lobby-kit/pill.large.png",
      "pixelW": 764,
      "pixelH": 248,
      "alpha": true,
      "transparentPixels": 27877,
      "partialAlphaPixels": 161595,
      "sha256": "ef0dfd59006c43eb404b312696ed4ad5c96f389f880acf85fcb3aaa1ca6de8e3",
      "reused": true,
      "slicePx": {
        "top": 0,
        "right": 124,
        "bottom": 0,
        "left": 124
      }
    },
    "cta.plate.png": {
      "path": "apps/client/public/art/lobby-kit/cta.plate.png",
      "pixelW": 1736,
      "pixelH": 326,
      "alpha": true,
      "transparentPixels": 56991,
      "partialAlphaPixels": 508945,
      "sha256": "ae9529479f4f35a908b8acd3f2e196be029ae229eb90d3b4dc969e7d8e7dcdde",
      "reused": true,
      "slicePx": {
        "top": 0,
        "right": 331,
        "bottom": 0,
        "left": 331
      }
    },
    "icon.paper-plane": {
      "path": "apps/client/public/art/lobby-kit/icon.paper-plane.png",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "transparentPixels": 32345,
      "partialAlphaPixels": 1310,
      "sha256": "1ebf164032b6d614a3da2e8210aab9cfb0f6513f3d396161c7faee80976b549c",
      "reused": true
    }
  },
  "elements": [
    {
      "id": "backdrop.scrim",
      "piece": "scrim",
      "x": 0,
      "y": 0,
      "w": 941,
      "h": 1672,
      "render": "image",
      "z": 60,
      "filter": "none",
      "className": "sheet-backdrop"
    },
    {
      "id": "frame",
      "piece": "frame",
      "x": 60,
      "y": 548.97,
      "w": 820,
      "h": 733.37,
      "render": "border-image",
      "z": 61,
      "filter": "none",
      "className": "howto-panel mc-panel",
      "slicePx": {
        "top": 58,
        "right": 58,
        "bottom": 58,
        "left": 58
      },
      "borderWidthStage": {
        "top": 58,
        "right": 58,
        "bottom": 58,
        "left": 58
      }
    },
    {
      "id": "palm.tl",
      "piece": "palm.tl",
      "x": 60,
      "y": 548.97,
      "w": 246,
      "h": 222,
      "render": "image",
      "z": 62,
      "filter": "none",
      "className": "ht-palm ht-palm-tl"
    },
    {
      "id": "palm.tr",
      "piece": "palm.tr",
      "x": 634,
      "y": 548.97,
      "w": 246,
      "h": 222,
      "render": "image",
      "z": 62,
      "filter": "none",
      "className": "ht-palm ht-palm-tr"
    },
    {
      "id": "palm.bl",
      "piece": "palm.bl",
      "x": 60,
      "y": 1060.34,
      "w": 246,
      "h": 222,
      "render": "image",
      "z": 62,
      "filter": "none",
      "className": "ht-palm ht-palm-bl"
    },
    {
      "id": "palm.br",
      "piece": "palm.br",
      "x": 634,
      "y": 1060.34,
      "w": 246,
      "h": 222,
      "render": "image",
      "z": 62,
      "filter": "none",
      "className": "ht-palm ht-palm-br"
    },
    {
      "id": "title.rule",
      "piece": "rule",
      "x": 294,
      "y": 774.97,
      "w": 352,
      "h": 28,
      "render": "image",
      "z": 63,
      "filter": "none",
      "className": "ht-rule"
    },
    {
      "id": "field.plate",
      "piece": "pill.large.png",
      "x": 139.42,
      "y": 874.97,
      "w": 661.16,
      "h": 118.67,
      "render": "3-slice",
      "z": 63,
      "filter": "none",
      "className": "mc-field::before",
      "slicePx": {
        "top": 0,
        "right": 124,
        "bottom": 0,
        "left": 124
      },
      "borderWidthStage": {
        "top": 0,
        "right": 59.33,
        "bottom": 0,
        "left": 59.33
      },
      "capFormula": "118.67 × 124 / 248 = 59.335; existing CSS rounds to 59.33"
    },
    {
      "id": "field.mail",
      "piece": "icon.paper-plane",
      "x": 188.45,
      "y": 916.69,
      "w": 49.23,
      "h": 35.07,
      "render": "image",
      "z": 64,
      "filter": "none",
      "className": "mc-mail",
      "sourceRect": null,
      "objectFit": "fill",
      "note": "Whole existing PNG canvas at the exact mc-mail box; no crop, tint, or new piece."
    },
    {
      "id": "field.divider",
      "piece": null,
      "x": 258.58,
      "y": 907.25,
      "w": 1.35,
      "h": 53.95,
      "render": "existing-css-border",
      "z": 64,
      "filter": "none",
      "className": "mc-field input",
      "color": "#6f8fd8"
    },
    {
      "id": "send.plate",
      "piece": "cta.plate.png",
      "x": 142.02,
      "y": 1001.44,
      "w": 655.96,
      "h": 126.28,
      "render": "3-slice",
      "z": 63,
      "filter": "none",
      "className": "mc-send::before",
      "slicePx": {
        "top": 0,
        "right": 331,
        "bottom": 0,
        "left": 331
      },
      "borderWidthStage": {
        "top": 0,
        "right": 128.2,
        "bottom": 0,
        "left": 128.2
      },
      "capFormula": "126.28 × 331 / 326 = 128.216809816; existing mc-send CSS rounds to 128.2"
    },
    {
      "id": "close",
      "piece": "close",
      "x": 704,
      "y": 584.97,
      "w": 140,
      "h": 140,
      "render": "image",
      "z": 66,
      "filter": "none",
      "className": "ht-close img"
    }
  ],
  "texts": [
    {
      "id": "title",
      "text": "MESSAGE SAMANTHA",
      "x": 172,
      "y": 672.97,
      "w": 534,
      "h": 60,
      "role": "title",
      "font": "Nunito",
      "fontToken": "--font-ui",
      "size": 48,
      "weight": 800,
      "lineHeight": 60,
      "trackingEm": 0,
      "color": "#ffffff",
      "align": "center",
      "className": "ht-title",
      "z": 65,
      "binding": "recipient.displayName.toUpperCase()",
      "spans": [
        {
          "text": "MESSAGE ",
          "flex": "none"
        },
        {
          "text": "SAMANTHA",
          "binding": "recipient.displayName.toUpperCase()",
          "minWidth": 0,
          "overflow": "hidden",
          "textOverflow": "ellipsis",
          "whiteSpace": "nowrap"
        }
      ],
      "overflow": "ellipsis on recipient span only; prefix never truncates; never wrap or shrink",
      "positionOverride": "ht-head width 534, still at default content origin; same 104 minimum height"
    },
    {
      "id": "last.line",
      "text": "Samantha: That was close! I thought you'd go all the way. One more round?",
      "x": 172,
      "y": 822.97,
      "w": 596,
      "h": 32,
      "role": "last.line",
      "font": "Nunito",
      "fontToken": "--font-ui",
      "size": 22,
      "weight": 600,
      "lineHeight": 32,
      "trackingEm": 0,
      "color": "#b9c8e8",
      "align": "left",
      "className": "mc-note",
      "z": 65,
      "binding": "newest thread message whose fromId equals the frozen recipient.id; prefix recipient.displayName + \": \"",
      "optional": true,
      "displayText": "Samantha: That was close! I thought you'd go all the way.…",
      "overflow": "one line; ellipsis; no text-size change; no thread view",
      "lineBreaks": "display CR/LF as spaces in this one-line excerpt; stored message unchanged",
      "ariaLabel": "Full last incoming message"
    },
    {
      "id": "field.input",
      "text": "",
      "x": 280.93,
      "y": 907.25,
      "w": 477.65,
      "h": 53.95,
      "role": "field.input",
      "font": "Nunito",
      "fontToken": "--font-ui",
      "size": 25,
      "weight": 600,
      "lineHeight": 53.95,
      "trackingEm": 0,
      "color": "#ffffff",
      "align": "left",
      "className": "mc-field input",
      "z": 65,
      "placeholder": "Write to Samantha…",
      "placeholderColor": "#9eb3e9",
      "binding": "draft.text",
      "placeholderBinding": "\"Write to \" + recipient.displayName + \"…\"",
      "maxLength": 500,
      "overflow": "native single-line input horizontal editing, not a popup scroll",
      "boxModel": {
        "inputBox": {
          "x": 258.58,
          "y": 907.25,
          "w": 500,
          "h": 53.95
        },
        "paddingLeft": 21,
        "borderLeft": 1.35
      }
    },
    {
      "id": "send.label",
      "text": "SEND",
      "x": 142.02,
      "y": 1036.58,
      "w": 655.96,
      "h": 56,
      "role": "send.label",
      "font": "Nunito",
      "fontToken": "--font-ui",
      "size": 56,
      "weight": 800,
      "lineHeight": 56,
      "trackingEm": 0.01,
      "color": "#000000",
      "align": "center",
      "className": "mc-send",
      "z": 65
    },
    {
      "id": "note",
      "text": "Only Samantha sees it",
      "x": 118,
      "y": 1148.34,
      "w": 704,
      "h": 32,
      "role": "note",
      "font": "Nunito",
      "fontToken": "--font-ui",
      "size": 22,
      "weight": 600,
      "lineHeight": 32,
      "trackingEm": 0,
      "color": "#b9c8e8",
      "align": "center",
      "className": "mc-note",
      "z": 65,
      "binding": "canMessage ? \"Only \" + recipient.displayName + \" sees it\" : \"Friends only after the match\""
    }
  ],
  "hitTargets": [
    {
      "id": "backdrop",
      "x": 0,
      "y": 0,
      "w": 941,
      "h": 1672,
      "z": 60,
      "action": "close-message",
      "enabled": true,
      "stopPropagation": true,
      "exclude": "popup bounds; content consumes taps"
    },
    {
      "id": "popup.body",
      "x": 60,
      "y": 548.97,
      "w": 820,
      "h": 733.37,
      "z": 61,
      "action": "consume-tap",
      "enabled": true,
      "stopPropagation": true
    },
    {
      "id": "field",
      "x": 139.42,
      "y": 874.97,
      "w": 661.16,
      "h": 118.67,
      "z": 64,
      "action": "focus existing input",
      "enabled": true,
      "stopPropagation": true,
      "ariaLabel": "Write to Samantha",
      "implementation": "The whole existing mc-field is the focus target (label for the input or wrapper focus handler), including the mark and empty plate; the native input remains inside. No overlay that blocks caret selection."
    },
    {
      "id": "send",
      "x": 142.02,
      "y": 1001.44,
      "w": 655.96,
      "h": 126.28,
      "z": 65,
      "action": "POST /api/social/messages {toId: frozen recipient.id, text: trimmed draft}",
      "enabled": false,
      "stopPropagation": true,
      "ariaLabel": "Send",
      "disabledBehavior": "consume tap; no POST and no popup close"
    },
    {
      "id": "close",
      "x": 716,
      "y": 596.97,
      "w": 116,
      "h": 116,
      "z": 66,
      "action": "close-message",
      "enabled": true,
      "stopPropagation": true,
      "ariaLabel": "Close message"
    }
  ],
  "states": {
    "idle": {
      "elementOverrides": {
        "send.plate": {
          "filter": "brightness(.5)"
        }
      },
      "hitOverrides": {
        "send": {
          "enabled": false,
          "stopPropagation": true
        }
      },
      "textRule": "SEND stays black; only existing gold plate is dimmed",
      "canMessage": true,
      "draft": "",
      "lastLine": null,
      "hiddenTexts": [
        "last.line"
      ],
      "textOverrides": {
        "field.input": {
          "text": "",
          "displayText": "Write to Samantha…",
          "color": "#9eb3e9"
        },
        "note": {
          "text": "Only Samantha sees it"
        }
      },
      "movement": 0
    },
    "armed": {
      "canMessage": true,
      "draft": "That was close!",
      "lastLine": null,
      "hiddenTexts": [
        "last.line"
      ],
      "elementOverrides": {
        "send.plate": {
          "filter": "none"
        }
      },
      "hitOverrides": {
        "send": {
          "enabled": true,
          "stopPropagation": true
        }
      },
      "textOverrides": {
        "field.input": {
          "text": "That was close!",
          "color": "#ffffff"
        },
        "note": {
          "text": "Only Samantha sees it"
        }
      },
      "movement": 0
    },
    "with_last_line": {
      "elementOverrides": {
        "send.plate": {
          "filter": "brightness(.5)"
        }
      },
      "hitOverrides": {
        "send": {
          "enabled": false,
          "stopPropagation": true
        }
      },
      "textRule": "SEND stays black; only existing gold plate is dimmed",
      "canMessage": true,
      "draft": "",
      "lastLine": "Samantha: That was close! I thought you'd go all the way. One more round?",
      "hiddenTexts": [],
      "textOverrides": {
        "last.line": {
          "text": "Samantha: That was close! I thought you'd go all the way. One more round?",
          "displayText": "Samantha: That was close! I thought you'd go all the way.…"
        },
        "field.input": {
          "text": "",
          "displayText": "Write to Samantha…",
          "color": "#9eb3e9"
        },
        "note": {
          "text": "Only Samantha sees it"
        }
      },
      "movement": 0,
      "composesWith": "armed when user types; incoming text alone does not arm SEND"
    },
    "not_allowed": {
      "elementOverrides": {
        "send.plate": {
          "filter": "brightness(.5)"
        }
      },
      "hitOverrides": {
        "send": {
          "enabled": false,
          "stopPropagation": true
        }
      },
      "textRule": "SEND stays black; only existing gold plate is dimmed",
      "canMessage": false,
      "draft": "That was close!",
      "lastLine": null,
      "hiddenTexts": [
        "last.line"
      ],
      "textOverrides": {
        "field.input": {
          "text": "That was close!",
          "color": "#ffffff"
        },
        "note": {
          "text": "Friends only after the match"
        }
      },
      "movement": 0,
      "trigger": "canMessage false after match end, or POST returns 403 FRIENDS_ONLY; preserve draft",
      "fieldBehavior": "draft remains editable; send is disabled"
    }
  },
  "popup": {
    "component": "PopupPanel",
    "plate": "howto",
    "cls": "mc-panel",
    "place": {
      "x": 60,
      "y": 548.97,
      "w": 820
    },
    "height": 733.37,
    "heightRule": "last note bottom + default padding-bottom 44 + border-bottom 58; 9-slice, not a new fixed-height bitmap",
    "palms": true,
    "rule": true,
    "head": true,
    "titleArt": null,
    "dim": {
      "piece": "scrim",
      "element": "backdrop.scrim",
      "x": 0,
      "y": 0,
      "w": 941,
      "h": 1672,
      "sourceRgba": [
        4,
        6,
        20,
        184
      ],
      "effectiveOpacity": 0.7215686274509804,
      "z": 60,
      "className": "sheet-backdrop howto-backdrop",
      "source": "app.css:1646 overrides the older rgba rule at line 657; main.tsx:18 resolves the existing PNG"
    },
    "scroll": "none; every state keeps identical geometry",
    "contentBottom": 1180.34,
    "selectionReason": "The default frame supplies the existing live Nunito title, rule and corner controls without crew title artwork or unused quick-message rows.",
    "coordinateContract": "Absolute children of howto-panel use its padding-box origin: inline CSS left/top = stored stage x/y minus popup place x/y minus 58 border. Normal-flow ht-head/rule retain default padding. Do not add the 58 border twice.",
    "headerLane": {
      "defaultWidth": 596,
      "safeWidth": 534,
      "closeGap": 10,
      "reason": "Reserve the close button hit box plus its existing 10-unit corner offset as text clearance; preserve left content margin and 48px title."
    },
    "composer": {
      "fieldLocal": {
        "x": 79.42000000000002,
        "y": 326,
        "w": 661.16,
        "h": 118.67
      },
      "sendLocal": {
        "x": 82.01999999999998,
        "y": 452.47,
        "w": 655.96,
        "h": 126.28
      },
      "lastLineLocal": {
        "x": 112,
        "y": 274,
        "w": 596,
        "h": 32
      },
      "noteLocal": {
        "x": 58,
        "y": 599.37,
        "w": 704,
        "h": 32
      },
      "reserveLastLineWhenAbsent": true
    },
    "verticalAnchor": {
      "crewPlace": {
        "x": 72.14,
        "y": 344.34,
        "w": 790
      },
      "crewNoteLocalY": 804,
      "sharedNoteStageY": 1148.34,
      "fieldToSendGap": 7.8,
      "sendToNoteGap": 20.62
    },
    "zOrder": "Untouched PREDICT board, shared backdrop, sliced frame, palms, pieces, live text, close. The player card is replaced by this composer.",
    "flow": {
      "purpose": "Keep PopupPanel height auto. Only placement properties are overridden inline on the existing classes; no new CSS class or surface. Palms and close retain their normal absolute anchoring.",
      "header": {
        "className": "ht-head",
        "style": {
          "width": 534
        },
        "minHeight": 104
      },
      "title": {
        "className": "ht-title",
        "style": {
          "display": "flex",
          "maxWidth": "100%",
          "whiteSpace": "nowrap"
        },
        "prefix": {
          "flex": "none"
        },
        "name": {
          "minWidth": 0,
          "overflow": "hidden",
          "textOverflow": "ellipsis"
        }
      },
      "rule": {
        "className": "ht-rule",
        "style": "unchanged"
      },
      "lastLine": {
        "className": "mc-note",
        "style": {
          "position": "relative",
          "left": 0,
          "right": "auto",
          "top": "auto",
          "width": 596,
          "height": 32,
          "margin": "20px 0 0",
          "textAlign": "left",
          "whiteSpace": "nowrap",
          "overflow": "hidden",
          "textOverflow": "ellipsis"
        },
        "absent": "visibility:hidden; reserve same 32px line and margins"
      },
      "field": {
        "className": "mc-field",
        "style": {
          "position": "relative",
          "left": -32.58,
          "top": "auto",
          "margin": "20px 0 0"
        },
        "children": "mc-mail and input styles completely unchanged"
      },
      "send": {
        "className": "mc-send",
        "style": {
          "position": "relative",
          "left": -29.98,
          "top": "auto",
          "margin": "7.8px 0 0"
        }
      },
      "note": {
        "className": "mc-note",
        "style": {
          "position": "relative",
          "left": -54,
          "right": "auto",
          "top": "auto",
          "width": 704,
          "height": 32,
          "margin": "20.62px 0 0",
          "whiteSpace": "nowrap"
        }
      },
      "parentHeight": "auto = 58 + 44 + 104 + 20 + 28 + 20 + 32 + 20 + 118.67 + 7.8 + 126.28 + 20.62 + 32 + 44 + 58 = 733.37; do not use absolute children without reserving flow height"
    }
  },
  "textContract": {
    "font": "Nunito",
    "fontFile": "apps/client/public/fonts/Nunito-latin.woff2",
    "measurement": "Repository HarfBuzz/FreeType mask method from preview/tools/render-stage2.mjs and font-stage2.py; native variable weight, 2x raster; no substitute font, scaling, or fit-to-word changes",
    "title": {
      "size": 48,
      "lineHeight": 60,
      "weight": 800,
      "prefixAdvance": 245.184,
      "nameLane": 288.816,
      "cases": {
        "SAMANTHA": {
          "characters": 8,
          "fullNameAdvance": 284.832,
          "fullTitleAdvance": 530.016,
          "nameLane": 288.816,
          "displayName": "SAMANTHA",
          "displayTitle": "MESSAGE SAMANTHA",
          "renderedAdvance": 530.016,
          "fitsWithoutEllipsis": true
        },
        "ALEXANDRIELLE": {
          "characters": 13,
          "fullNameAdvance": 394.992,
          "fullTitleAdvance": 640.176,
          "nameLane": 288.816,
          "displayName": "ALEXAND…",
          "displayTitle": "MESSAGE ALEXAND…",
          "renderedAdvance": 514.992,
          "fitsWithoutEllipsis": false
        },
        "WWWWWWWWWWWWW": {
          "characters": 13,
          "fullNameAdvance": 698.88,
          "fullTitleAdvance": 944.064,
          "nameLane": 288.816,
          "displayName": "WWWW…",
          "displayTitle": "MESSAGE WWWW…",
          "renderedAdvance": 494.928,
          "fitsWithoutEllipsis": false
        }
      }
    },
    "lastLine": {
      "size": 22,
      "lineHeight": 32,
      "weight": 600,
      "laneWidth": 596,
      "presentationMaxCharacters": "Width-based ellipsis, not a universal character count. Measured maxima include full visible prefix and ellipsis; do not truncate the stored 500-character message.",
      "capacities": {
        "Samantha: ": {
          "W": {
            "bodyCharacters": 19,
            "totalVisibleCharacters": 30,
            "advance": 589.996,
            "nextAdvance": 614.35
          },
          "i": {
            "bodyCharacters": 87,
            "totalVisibleCharacters": 98,
            "advance": 593.56,
            "nextAdvance": 598.906
          }
        },
        "WWWWWWWWWWWWW: ": {
          "W": {
            "bodyCharacters": 10,
            "totalVisibleCharacters": 26,
            "advance": 584.98,
            "nextAdvance": 609.334
          },
          "i": {
            "bodyCharacters": 47,
            "totalVisibleCharacters": 63,
            "advance": 593.89,
            "nextAdvance": 599.236
          }
        }
      },
      "widestPrintableAscii": {
        "ch": "W",
        "advance": 24.354
      },
      "fixture": {
        "text": "Samantha: That was close! I thought you'd go all the way. One more round?",
        "display": "Samantha: That was close! I thought you'd go all the way.…",
        "fullAdvance": 757.548,
        "displayAdvance": 594.352
      }
    },
    "note": "22/32 weight 600 #b9c8e8 unchanged",
    "input": "25/53.95 weight 600; unchanged mc-field box, padding and separator",
    "send": "56/56 weight 800 black, .01em tracking, 655.96 × 126.28; unchanged mc-send"
  },
  "behavior": {
    "recipient": "Snapshot recipient id and name when opening. A game target/phase change never retargets the draft or restarts any game clock.",
    "thread": "GET /api/social/messages/:otherId returns oldest first; select the final incoming message, not simply the final message, and honor canMessage.",
    "sendEnabled": "canMessage && !busy && trimmed draft length > 0 && trimmed draft length <= 500",
    "maxLength": 500,
    "sendSuccess": "Close composer only after successful POST; showToast(\"Sent\") using existing game toast after close.",
    "sending": {
      "plate": "brightness(.5)",
      "sendEnabled": false,
      "note": "Sending…",
      "draft": "retain until success",
      "geometry": "unchanged"
    },
    "permissionError": "403 FRIENDS_ONLY -> not_allowed; preserve draft and recipient; no new error surface",
    "otherError": "Keep draft, stay open, clear busy and use existing error toast. Return to armed if canMessage remains true; no extra popup lane.",
    "whitespaceOnly": "idle SEND behavior; no POST",
    "keyboard": "Enter submits only when sendEnabled, matching CrewSheet; no autofocus is specified. Keyboard/device behavior is not verified by these PNGs.",
    "closing": "Only × or backdrop dismisses. Taps in title, field, SEND, note and panel do not dismiss or reach the game.",
    "optionalContext": "Reserved last-line lane remains empty when no incoming message. Adding/removing it never moves the field or SEND."
  },
  "verification": {
    "sourceDimensions": true,
    "noNewPieces": true,
    "outputCount": 6,
    "stateCount": 4,
    "previewMethod": "Offline Sharp raster composition over var/out/predict-flirt.png, unchanged board geometry; no stage-2 reference-fixture warp.",
    "browser": "Not run: installed Chromium launch failed with sandbox_host_linux.cc shutdown Operation not permitted; no browser or device verification claimed.",
    "proofs": [
      {
        "state": "idle",
        "file": "preview-idle-941.png",
        "width": 941,
        "height": 1672,
        "sha256": "978736b5afd90cefbc7f38bf26ec38f222fc918aa73a376d2e6abfb31c137c3b",
        "texts": [
          {
            "id": "title",
            "text": "MESSAGE ",
            "advance": 245.184,
            "x": 173.992,
            "baseline": 718.762,
            "inkY": 684.262,
            "inkW": 229,
            "inkH": 36
          },
          {
            "id": "title",
            "text": "SAMANTHA",
            "advance": 284.832,
            "x": 419.176,
            "baseline": 718.762,
            "inkY": 684.262,
            "inkW": 282,
            "inkH": 36
          },
          {
            "id": "field.input",
            "text": "Write to Samantha…",
            "advance": 233.85,
            "x": 280.93,
            "baseline": 942.45,
            "inkY": 924.45,
            "inkW": 232,
            "inkH": 19
          },
          {
            "id": "send.label",
            "text": "SEND",
            "advance": 156.968,
            "x": 391.516,
            "baseline": 1083.004,
            "inkY": 1042.504,
            "inkW": 153,
            "inkH": 42
          },
          {
            "id": "note",
            "text": "Only Samantha sees it",
            "advance": 225.104,
            "x": 357.448,
            "baseline": 1171.578,
            "inkY": 1155.578,
            "inkW": 225,
            "inkH": 21
          }
        ]
      },
      {
        "state": "armed",
        "file": "preview-armed-941.png",
        "width": 941,
        "height": 1672,
        "sha256": "f2394060107e72e36c32ded352aff4351bb3fc0ff91ca4be5d1ae295e75a756c",
        "texts": [
          {
            "id": "title",
            "text": "MESSAGE ",
            "advance": 245.184,
            "x": 173.992,
            "baseline": 718.762,
            "inkY": 684.262,
            "inkW": 229,
            "inkH": 36
          },
          {
            "id": "title",
            "text": "SAMANTHA",
            "advance": 284.832,
            "x": 419.176,
            "baseline": 718.762,
            "inkY": 684.262,
            "inkW": 282,
            "inkH": 36
          },
          {
            "id": "field.input",
            "text": "That was close!",
            "advance": 177.6,
            "x": 280.93,
            "baseline": 942.45,
            "inkY": 924.45,
            "inkW": 177,
            "inkH": 19
          },
          {
            "id": "send.label",
            "text": "SEND",
            "advance": 156.968,
            "x": 391.516,
            "baseline": 1083.004,
            "inkY": 1042.504,
            "inkW": 153,
            "inkH": 42
          },
          {
            "id": "note",
            "text": "Only Samantha sees it",
            "advance": 225.104,
            "x": 357.448,
            "baseline": 1171.578,
            "inkY": 1155.578,
            "inkW": 225,
            "inkH": 21
          }
        ]
      },
      {
        "state": "with_last_line",
        "file": "preview-with_last_line-941.png",
        "width": 941,
        "height": 1672,
        "sha256": "4d8242b855859e4d95f8315a78c3274db8af51a5ee73ba02b1bf0ed2e2e7f5c8",
        "texts": [
          {
            "id": "title",
            "text": "MESSAGE ",
            "advance": 245.184,
            "x": 173.992,
            "baseline": 718.762,
            "inkY": 684.262,
            "inkW": 229,
            "inkH": 36
          },
          {
            "id": "title",
            "text": "SAMANTHA",
            "advance": 284.832,
            "x": 419.176,
            "baseline": 718.762,
            "inkY": 684.262,
            "inkW": 282,
            "inkH": 36
          },
          {
            "id": "last.line",
            "text": "Samantha: That was close! I thought you'd go all the way.…",
            "advance": 594.352,
            "x": 172,
            "baseline": 846.208,
            "inkY": 830.208,
            "inkW": 592,
            "inkH": 21
          },
          {
            "id": "field.input",
            "text": "Write to Samantha…",
            "advance": 233.85,
            "x": 280.93,
            "baseline": 942.45,
            "inkY": 924.45,
            "inkW": 232,
            "inkH": 19
          },
          {
            "id": "send.label",
            "text": "SEND",
            "advance": 156.968,
            "x": 391.516,
            "baseline": 1083.004,
            "inkY": 1042.504,
            "inkW": 153,
            "inkH": 42
          },
          {
            "id": "note",
            "text": "Only Samantha sees it",
            "advance": 225.104,
            "x": 357.448,
            "baseline": 1171.578,
            "inkY": 1155.578,
            "inkW": 225,
            "inkH": 21
          }
        ]
      },
      {
        "state": "not_allowed",
        "file": "preview-not_allowed-941.png",
        "width": 941,
        "height": 1672,
        "sha256": "87cc972b70c22e5a34ada1c8610aa7b3b3d163d5bf4f423c409632cfc0932a28",
        "texts": [
          {
            "id": "title",
            "text": "MESSAGE ",
            "advance": 245.184,
            "x": 173.992,
            "baseline": 718.762,
            "inkY": 684.262,
            "inkW": 229,
            "inkH": 36
          },
          {
            "id": "title",
            "text": "SAMANTHA",
            "advance": 284.832,
            "x": 419.176,
            "baseline": 718.762,
            "inkY": 684.262,
            "inkW": 282,
            "inkH": 36
          },
          {
            "id": "field.input",
            "text": "That was close!",
            "advance": 177.6,
            "x": 280.93,
            "baseline": 942.45,
            "inkY": 924.45,
            "inkW": 177,
            "inkH": 19
          },
          {
            "id": "send.label",
            "text": "SEND",
            "advance": 156.968,
            "x": 391.516,
            "baseline": 1083.004,
            "inkY": 1042.504,
            "inkW": 153,
            "inkH": 42
          },
          {
            "id": "note",
            "text": "Friends only after the match",
            "advance": 281.16,
            "x": 329.42,
            "baseline": 1171.578,
            "inkY": 1155.578,
            "inkW": 279,
            "inkH": 21
          }
        ]
      }
    ],
    "sources": [
      {
        "path": "apps/client/src/main.tsx",
        "sha256": "f889002f12b81360d49fc4373067c728cf247c593bcfe06d87f7d17828c0dfc8"
      },
      {
        "path": "apps/client/src/net/api.ts",
        "sha256": "2d3a31d63c97d122b5b44db80ff8fdc47c48918c133190bb8c6c7fa8ecc16986"
      },
      {
        "path": "apps/client/src/ui/CrewSheet.tsx",
        "sha256": "550efabea887b7440d27b9b217a9ef6452bece11937494581e31f3b201004a4b"
      },
      {
        "path": "apps/client/src/ui/PopupPanel.tsx",
        "sha256": "f7bca605701ee21795effead81c31a2c07a561427a6cc18c8cbb23e3ff4b553f"
      },
      {
        "path": "apps/client/src/screens/HowTo.tsx",
        "sha256": "6f1ac3d7134bb972d37ff6683d3bac0644571b1d989c17a96b20d616fedd8d6a"
      },
      {
        "path": "apps/client/src/ui/RoomSettingsPanel.tsx",
        "sha256": "f5c1a9436b2573e784e0b1d381fa409c39a9816a06e38a2178f30c00d8abf6e5"
      },
      {
        "path": "apps/client/src/styles/app.css",
        "sha256": "26ca4c59530ab10f6636875c99f0bf2c29688df9ae53380e2a266cf8d77dee43"
      },
      {
        "path": "apps/client/src/styles/tokens.css",
        "sha256": "3977f03e4ba417b5cd6dacc868eb49c5f977935eb812373171295d047d0a6df9"
      },
      {
        "path": "art/src/player-card-2026-10-07/preview/tools/render-stage2.mjs",
        "sha256": "27ae4553d6beb3f421b3d6ce0276a903bba922e26514b9e81c3ee5605bd264fb"
      },
      {
        "path": "art/src/player-card-2026-10-07/preview/tools/font-stage2.py",
        "sha256": "830a7581e49e014df7cf681979debae243c81fdde3fa712457d2228fdedf02a1"
      },
      {
        "path": "var/out/predict-flirt.png",
        "sha256": "5cf6052a8702efd526c8f77f6eaa4c24050bde3587eaca20a6cb21ebc7b451b1"
      }
    ],
    "font": {
      "path": "apps/client/public/fonts/Nunito-latin.woff2",
      "sha256": "ba344451eab25b217a165363b1982048a5e5830a0daf36577973955a04cac793",
      "metrics": {
        "unitsPerEm": 1000,
        "ascender": 1011,
        "descender": -353,
        "height": 1364
      }
    },
    "type": [
      {
        "id": "title",
        "size": 48,
        "floor": 14,
        "css360": 18.363443,
        "pass": true
      },
      {
        "id": "field",
        "size": 25,
        "floor": 16,
        "css360": 9.564293,
        "pass": false
      },
      {
        "id": "send",
        "size": 56,
        "floor": 16,
        "css360": 21.424017,
        "pass": true
      },
      {
        "id": "last.line",
        "size": 22,
        "floor": 14,
        "css360": 8.416578,
        "pass": false
      },
      {
        "id": "note",
        "size": 22,
        "floor": 14,
        "css360": 8.416578,
        "pass": false
      }
    ],
    "hits": [
      {
        "id": "field",
        "w": 661.16,
        "h": 118.67,
        "css360": [
          252.941126,
          45.399787
        ],
        "pass": true
      },
      {
        "id": "send",
        "w": 655.96,
        "h": 126.28,
        "css360": [
          250.951753,
          48.311158
        ],
        "pass": true
      },
      {
        "id": "close",
        "w": 116,
        "h": 116,
        "css360": [
          44.378321,
          44.378321
        ],
        "pass": true
      }
    ],
    "noScroll": {
      "frameBottom": 1282.34,
      "stageBottom": 1672,
      "bottomMargin": 389.66,
      "lastNoteBottom": 1180.34,
      "sameGeometryAllStates": true
    },
    "fieldText": {
      "laneWidth": 477.65,
      "placeholderAdvance": 233.85,
      "thirteenWideNamePlaceholderAdvance": 476.65
    },
    "cta": {
      "wordAdvance": 156.968,
      "imageWidth": 655.96,
      "horizontalCanvasMargin": 249.496,
      "wordFraction": 0.239295
    },
    "hitOverlaps": [],
    "readSourcesUnchanged": true,
    "measuredText": {
      "Only Samantha sees it": {
        "advance": 225.104,
        "inkW": 224.5,
        "inkH": 20.5,
        "missingGlyphs": []
      },
      "Friends only after the match": {
        "advance": 281.16,
        "inkW": 278.5,
        "inkH": 20.5,
        "missingGlyphs": []
      }
    }
  },
  "deviations": [
    {
      "id": "inherited-text-floor",
      "status": "MEASURED",
      "detail": "The exact 25px mc-field and 22px mc-note requested by the brief are below older 16/14 CSS-px floors at 360. Kept unchanged because the brief explicitly fixes existing sizes and forbids enlargement; not reported as a passing mobile-readability check."
    },
    {
      "id": "paper-plane",
      "status": "BRIEF-AUTHORITATIVE",
      "detail": "CrewSheet currently references ui4b/icon-envelope@2x.png; the brief explicitly requests lobby-kit/icon.paper-plane.png. Reused that existing PNG in the unmodified mc-mail image box."
    }
  ],
  "notes": [
    "Flattened PNGs are review compositions only. No popup graphics are baked into a landscape or exported as new runtime pieces.",
    "Existing source artwork, public assets and application files are read-only.",
    "Default title lane is narrowed only to clear the owner close control; font remains exactly 48/60. All other typography is the exact requested class typography."
  ]
}
